import { Constants } from "./constants";
import { Contact } from "./contact/_contact";
import { Dialogs } from "./dialogs/dialogs";
import { Faq } from "./faq/_faq";
import { Functions } from "./functions/_functions";
import { Logging } from "./logging";
import { Navigation } from "./navigation/_navigation";

//App.Common
export class Common {
    static readonly Constants = Constants;
    static readonly Contact = Contact;
    static readonly Faq = Faq;
    static readonly Functions = Functions;
    static readonly Logging = Logging;
    static readonly Navigation = Navigation;
    static readonly Dialogs = Dialogs;

    static init(): void {
        Functions.init();
        Navigation.init();
        Contact.init();
        Faq.init();
    }

}